import { render } from "./FoalMarkingData.vue?vue&type=template&id=ef9be4aa"
import script from "./FoalMarkingData.vue?vue&type=script&lang=js"
export * from "./FoalMarkingData.vue?vue&type=script&lang=js"

import "./FoalMarkingData.vue?vue&type=style&index=0&id=ef9be4aa&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__